module.exports = __webpack_public_path__ + "img/empresa_01.03703752.webp";